/**
 * @module ShowPasswordStrength
 */

/**
 * Props for the password strength indicator component
 * @public
 */
export interface ShowPasswordStrengthProps {
  /** Password strength level (0-3) */
  strength: 0 | 1 | 2 | 3;
}

/**
 * Component that displays password strength as a visual indicator
 * @remarks Shows three bars that fill up based on password strength
 */
export function ShowPasswordStrength({ strength }: ShowPasswordStrengthProps) {
  return (
    <div className="flex gap-1 justify-between mt-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="h-1.5 w-1/3	rounded-full"
          style={{
            backgroundColor:
              index < strength
                ? "var(--color-green-500)"
                : "var(--color-zinc-100)",
          }}
        />
      ))}
    </div>
  );
}
